import { useEffect } from 'react';

/** 브라우저 탭 / 검색 결과 / 스크린리더 페이지 전환 안내에 쓰이는 문서 제목 설정 */
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} | ${prev}`;
    return () => {
      document.title = prev;
    };
  }, [title]);
};
